import React from 'react';

import { Button, BUTTON } from 'components/common/Button/Button';
import Modal from 'components/common/Modal/Modal';

import styles from './StudyModal.scss';

const { COLOR, BGCOLOR } = BUTTON;

const StudyModal = ({
    isOpen,
    onClose,
    onSave,
    title,
    isDisabled,
    bodyContainer,
    onCancelText,
    onSaveText,
}) => {
    if (!isOpen) {
        return null;
    }
    
    return (
        <div className={styles.auditModal__wrapper} data-cy="StudyModal">
            <Modal title={title} open={isOpen} onClose={onClose}>
                <div className={styles.auditModal__body} data-cy="StudyModal-bodyContainer">{bodyContainer}</div>
                <div className={styles.auditModal__buttons}>
                    <Button
                        text={onCancelText}
                        outline={BUTTON.OUTCOLOR.MEDIUMGREY}
                        color={COLOR.BLACK}
                        bgcolor={BGCOLOR.WHITE}
                        onClick={onClose}
                        data-testid="ModalAudit__Btn__Cancel"
                        data-cy="StudyModal-Cancel"
                    />
                    <Button
                        text={onSaveText}
                        bgcolor={BGCOLOR.ORANGE}
                        color={COLOR.WHITE}
                        onClick={onSave}
                        disabled={isDisabled}
                        data-testid="ModalAudit__Btn__SaveChange"
                        data-cy="StudyModal-Save"
                    />
                </div>
            </Modal>
        </div>
    );
};

export default StudyModal;